import {DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, merge, Observable} from "rxjs";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {map} from "rxjs/operators";
import {PatientHealthEvent} from "@core/models/PatientHealthEvent";
import {PatientByIdHealthEventService} from "@core/http/table-data-services/patientByIdHealthEvent.service";

export class PatientByIdHealthEventDataSource extends DataSource<PatientHealthEvent> {
  filterChange = new BehaviorSubject('');
  filteredData: PatientHealthEvent[] = [];
  renderedData: PatientHealthEvent[] = [];

  constructor(
    public serviceDatabase: PatientByIdHealthEventService,
    public paginator: MatPaginator,
    public _sort: MatSort,
    public idPatient: string
  ) {
    super();
    this.filterChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  get filter(): string {
    return this.filterChange.value;
  }

  set filter(filter: string) {
    this.filterChange.next(filter);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<PatientHealthEvent[]> {
    const displayDataChanges = [
      this.serviceDatabase.dataChange,
      this._sort.sortChange,
      this.filterChange,
      this.paginator.page,
    ];
    this.serviceDatabase.getAllPatientByIdHealthEvents(this.idPatient);
    return merge(...displayDataChanges).pipe(
      map(() => {
        // Filter data
        this.filteredData = this.serviceDatabase.data
          .slice()
          .filter((healthEvent: PatientHealthEvent) => {
            const searchStr = (
              healthEvent.idPaciente +
              healthEvent.fecha +
              healthEvent.eventoDeSalud +
              healthEvent.descripcion +
              healthEvent.nombreEvento
            ).toLowerCase();
            return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
          });
        const sortedData = this.sortData(this.filteredData.slice());
        const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
        this.renderedData = sortedData.splice(
          startIndex,
          this.paginator.pageSize
        );
        return this.renderedData;
      })
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  disconnect() {
  }

  /** Returns a sorted copy of the database data. */
  sortData(data: PatientHealthEvent[]): PatientHealthEvent[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }
    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';
      switch (this._sort.active) {
        case 'idTipoUsuario':
          [propertyA, propertyB] = [a.idPaciente, b.idPaciente];
          break;
        case 'fecha' :
          [propertyA, propertyB] = [a.fecha, b.fecha];
          break;
        case 'eventoDeSalud' :
          [propertyA, propertyB] = [a.eventoDeSalud, b.eventoDeSalud];
          break;
        case 'descripcion' :
          [propertyA, propertyB] = [a.descripcion, b.descripcion];
          break;
        case 'nombreEvento' :
          [propertyA, propertyB] = [a.nombreEvento!, b.nombreEvento!];
          break;

      }
      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;
      return (
        (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1)
      );
    });
  }
}
